module.exports = "/_next/static/files/c7ee9a04719799b6cc307bd9ec9d4bd8.jpg";